import { Link } from "react-router-dom";
import { siteCategories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold text-background-50 tracking-tight">
                桃子视频
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              聚合香蕉视频、西瓜视频、蜜桃视频、樱桃视频等水果品牌影视资源，免费高清在线观看电影、电视剧、综艺，更新快不缓冲。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              影视分类
            </h3>
            <ul className="space-y-2">
              {siteCategories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              快捷链接
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/all"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                >
                  全部影视
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">
              联系我们
            </h3>
            <ul className="space-y-2 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@taozivideo.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区桃子大厦</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 桃子视频 Taozishipin.com 版权所有 | 京ICP备2024000001号
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">
                关于我们
              </Link>
              <span className="text-foreground-700">|</span>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">
                隐私政策
              </a>
              <span className="text-foreground-700">|</span>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors">
                用户协议
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}